import React from 'react';
import RebidLogo from '../../assets/images/logoRebid.png';
import * as FaIcons from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

export default function Footer() {
  const showSignup = useSelector((state) => state.menuReducer.showSignup);
  const history = useHistory();
  const routeChange = (url) => {
    url && history.push(url);
  };
  return (
    showSignup && (
      <footer className="footer">
        <div className="footer-top">
          <img className="footer-top_logo" src={RebidLogo} />
          <div className="footer-top_nav">
            <a
              href="https://www.rebid.co/about-us/"
              target="_blank"
              className="footer-top_nav-text"
              variant="overline"
            >
              About us
            </a>
            <a
              className="footer-top_nav-text"
              href="https://www.rebid.co/contact-us/"
              target="_blank"
              variant="overline"
            >
              Contact us
            </a>
            <a
              href="https://www.rebid.co/terms-of-use/"
              target="_blank"
              className="footer-top_nav-text"
              variant="overline"
            >
              Terms of use
            </a>
            {/* <span className="footer-top_nav-text" onClick={() => routeChange('/faq')}>
              {' '}
              FAQs
            </span> */}
            <a
              href="https://www.rebid.co/privacy-policy/"
              target="_blank"
              className="footer-top_nav-text"
              variant="overline"
            >
              Privacy policy
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom_link">
            <a
              className="footer-bottom_link-items"
              href="https://twitter.com/rdandx"
              target="_blank"
            >
              <FaIcons.FaTwitter width />
            </a>
            <a
              className="footer-bottom_link-items"
              href="https://www.linkedin.com/company/rdandxnetwork/"
              target="_blank"
            >
              <FaIcons.FaLinkedin />
            </a>
          </div>
          <p className="footer-bottom_copyright">Copyright © 2022 RD&X Group DMCC</p>
        </div>
      </footer>
    )
  );
}
